import { TenantByCompanySlugDocument, type TenantByCompanySlugQuery } from "~/gql/queries/portal.generated";
import publicClient from "~/services/publicClient";

const fetchTenantIdByCompanySlug = async (slug: string): Promise<string | null> => {
	const response = await publicClient.request<TenantByCompanySlugQuery>(TenantByCompanySlugDocument.toString(), {
		slug
	});
	return response.tenantByCompanySlug?.tenantId ?? null;
};

export default fetchTenantIdByCompanySlug;
